/*
	LTK.utils
Changes
	4 August 2014 - added LTK.newSelectElement and LTK.control
    31 August - Addedd check for "" on LTK.isNull()
    24 Dec 2014 - changed to use module pattern
    13 April - Added isValidJSONString and changed meaning of isJSONString
    2 March 2018 - Added getJsonFromUrl()
*/
var LTK = ( function() {
  var startTime = new Date().getTime();

  // Return number of milliseconds sinc start time
  var elapsedTime = function() {
    return new Date().getTime() - startTime;
  }

  var logLevel=0;		// 0 = none, 1 = INFO only, 2 = INFO + LOG
  var logKeywords=".";
  var logHide = [];		// List of keywords to hide lines
  

  function includesHiddenKeyword(element, index, array) {
    return this.indexOf( element ) > -1;
  }

  var log = function(text) {
    if ( logHide.some(includesHiddenKeyword, text) ) return;
    if (logLevel >= 2 || text.indexOf( logKeywords ) > -1 ) {
      console.log( elapsedTime() + ":" + logKeywords + ": " + text);
      jQuery("#ltk-log-trace").prepend( "LOG: " + elapsedTime() + ":" + text + "<br/>" );
    }
  };

  var setLogKeywords = function( keywords ) {
    logKeywords = keywords;
  };

  var MOD = "LTK.utils.";
  log( MOD + "JS...");



  var sleep = function(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  }

  
  var getJsonFromUrl = function() {
    var query = location.search.substr(1);
    var result = {};
    query.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  }

  var createCORSRequest = function(method, url) {
    var xhr = new XMLHttpRequest();
    if ("withCredentials" in xhr) {

      // Check if the XMLHttpRequest object has a "withCredentials" property.
      // "withCredentials" only exists on XMLHTTPRequest2 objects.
      xhr.open(method, url, true);

    } else if (typeof XDomainRequest != "undefined") {

      // Otherwise, check if XDomainRequest.
      // XDomainRequest only exists in IE, and is IE's way of making CORS requests.
      xhr = new XDomainRequest();
      xhr.open(method, url);

    } else {

      // Otherwise, CORS is not supported by the browser.
      xhr = null;

    }
    return xhr;
  }

  function toggleHidden(element) {
    //alert("hello from LTK");

    if ($(element).is(":hidden")) {
      $(element).show()
    } else {
      $(element).hide()
    }
  };

  var status=function(text) {
    window.status=text;
  };

  var warning = function(text) {
    console.warn("WARNING: " + elapsedTime() + ": " + text);
    jQuery("#ltk-log-trace").prepend( "WARNING: " + elapsedTime() + ":" + text + "<br/>" );
  };
  var error = function(text) {
    console.error("ERROR: " + elapsedTime() + ": " + text);
    jQuery("#ltk-log-trace").prepend( "ERROR: " + elapsedTime() + ":" + text + "<br/>" );
  };


  var info = function(text) {
    if (logLevel >= 1 || text.indexOf( logKeywords ) > -1 ) {
      console.info("INFO: " + elapsedTime() + ": " +  text);
      jQuery("#ltk-log-trace").prepend( "INFO: " + elapsedTime() + ":" + text + "<br/>" );
    }
    //send_alert(new Error("LTK.INFO: " + text));
  }

  var send_alert = function(error_object) {
    try {
      //	Remove the 'Error:' text from the start - doesnt work
      throw error_object;
    } catch(e) {
      //e.message=e.message.replace("Error:", "");
      _errs.push(e);
    }
  }

  var isNull = function(v){
    if (typeof(v) == "undefined" || v == null || v == "" ) 
      return true;
    else 
      return false;
  }

  var notNull = function(v){
    if (typeof(v) == "undefined" || v == null) 
      return false;
    else 
      return true;
  }
  //
  //	isBlank(v) - return TRUE if object or variable is null
  //
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  function isBlank( obj ) {
    var fn = MOD + "isBlank() ";
    //log( fn + "Object type: " + typeof( obj ) );
    
    if ( typeof( obj ) === "undefined" ) return true;
    if (obj == null) return true;
    if ( typeof( obj ) == "object" ) {
      // Object
      if (obj.length > 0)    return false;
      if (obj.length === 0)  return true;
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
      }
      return true;
    } else {
      //log( fn + "Object type: " + typeof( obj ) + " Val [" + obj + "]" );
      if ( obj == "" || obj == "{}" ) {
        return true;
      } 
      else {
        return false;
      }
    }
  }
  function notBlank( obj ) {
  	return ! isBlank( obj );
  };

  function objectAttributes(obj){
    var txt = "";
    for (i in obj) {
      if (!isNull(obj[i]) && obj[i] != "" && typeof(obj[i]) != "function") {
        txt += i + "=" + obj[i] + "; "
      }
    }
    return txt;
  }
  /*
	toText - returns elements/attributes of an object, seperated by 'sep'

*/
  var toText = function( obj, sep ) {
    var txt = "";

    if( isBlank( sep ) ) {
      sep="\n"
    }

    for (i in obj) {
      if (! isBlank(obj[i]) && obj[i] != "" && typeof(obj[i]) != "function") {
        txt += i + ": " + obj[i] + sep
      }
    }
    return txt;

  }

  var isValidJSONString = function(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  
  //	JSON string starts with '{'
  var isJSONString = function(str) {
    return str.substring(0) == '{' ? true : false;
  }


  var getToken = function(sVal, iIndex, sDelimiter){
    if (sVal == undefined || sDelimiter.length == 0) {
      return "";
    } else {
      var aSubString = new Array();
      aSubString = sVal.split(sDelimiter);

      if (iIndex > aSubString.length ||
          iIndex < 1) {
        return "";
      }
      else {
        return aSubString[iIndex - 1]
      }
    }
  }

  var httpGet = function(theUrl)
  {
    var xmlHttp = null;

    xmlHttp = new XMLHttpRequest();
    console.log(theUrl);
    xmlHttp.open( "GET", theUrl, false );
    xmlHttp.send( null );
    return xmlHttp.responseText;
  }

  function buildSelectOptionElement(existingValue, optionValue) {
    //log("buildSelectOptionElement() existingValue[" + existingValue +
    //        "] optionValue[" + optionValue + "]");
    if(existingValue == optionValue){	// Option should be the selected one
      return "<option value='" + optionValue + "' selected>" + optionValue + "</option>";
    } else {
      return "<option value='" + optionValue + "'>" + optionValue + "</option>";
    }
  }

  function newSelectElement(options, existingValue) {
    var element="<select>"
    //log("newSelectElement() options: " + options + "; Existing: " + existingValue);  
    jQuery.each(options, function(key, option) {
      element += buildSelectOptionElement(existingValue, option);
    });
    element += "</select>";
    return element;
  };

  //	getControlValue() - get the value of a control taking into account various children

  function getControlValue( control_id, field_type ) {
    var fn = MOD + "getControlValue() ";
    var control_value;
    

    if( isNull( field_type ) ) {	// Get first non-label field
      control_value = $( control_id ).find( ":not(label)" ).first().val();

    } else {	// Get first child of type 'field_type'
       control_value = $( control_id ).find( field_type ).first().val();
    }
    //log( fn + "control_id: " + control_id + ", field_type: " + field_type + ", control_value: " + control_value);
    return control_value;

  };

  //	Convert text to a handle. Note: this strips out accented characters
  // Logic is:
  //		Convert To Lower
  //		Replace everything that is not a letter/number or _ with space
  //		Delete repeating spaces
  //		Remove leading/trailing spaces
  //		Convert spaces to '-'
  //
  var handleize = function(text) {
    return text.toLowerCase().replace(/[^\w]|_/g, ' ').replace(/\s+/g,' ').trim().replace(/ /g, '-');
  }

  var listCookies = function () {
    var theCookies = document.cookie.split(';');
    var aString = '';
    for (var i = 1 ; i <= theCookies.length; i++) {
      aString += i + ' ' + theCookies[i-1] + "<br/>";
    }
    return aString;
  }

  var cookiesEnabled = function () {
    return navigator.cookieEnabled;
  }
  // Check height for all .read-more-containers.
  //	If more than x, clip & show read-more

  $(".read-more-container").each(function(index) {
    //console.log("read-more-container height:" + $(this).outerHeight( true ));
    var totalHeight=$(this).outerHeight( true );
    if (totalHeight > 300 ) {
      $(this).css("max-height", "300px");
      $(".read-more", this).show();
      //$(".read-more span").text(totalHeight)
    }
  });


  $(".read-more span").click(function() {

    var totalHeight = 0

    var $el = $(this);
    var $p  = $el.parent();
    var $container = $p.parent();

    // fade out read-more
    // It seems too difficult to calculate exact height so animate to 600 then set max-height to auto

    $p.fadeOut();
    $container.css({
      // Set height to prevent instant jumpdown when max height is removed
      "height": $container.outerHeight( true ),
      "max-height": 9999
    })
    .animate({

      "height": 800
    },1000, function() {
      // Animation complete.
      $container.css({
        "height": ''
      });
    });
    // prevent jump-down
    return false;
  });


  var viewport = function(width_element, height_element) {
    if (typeof(document.documentElement.clientWidth) != 'undefined') {
      var $w = document.getElementById(width_element),
          $h = document.getElementById(height_element),
          $ua = document.getElementById('ua');
      $w.innerHTML = document.documentElement.clientWidth;
      $h.innerHTML = ' &times; ' + document.documentElement.clientHeight;
      window.onresize = function(event) {
        $w.innerHTML = document.documentElement.clientWidth;
        $h.innerHTML = ' &times; ' + document.documentElement.clientHeight;
      };
      $ua.innerHTML = navigator.userAgent;
    }
  };

  log( MOD + "JS...OK");
  
  //	Public methods
  
  return {
    logLevel: logLevel,
    logHide: logHide,
    setLogKeywords: setLogKeywords,
    
    log: log,
    info: info,
    warning: warning,
    error: error,
    
    isBlank: isBlank,
    notBlank: notBlank,
    isNull: isNull,
    notNull: notNull,
    
    cookiesEnabled: cookiesEnabled,
    getJsonFromUrl: getJsonFromUrl,
    getToken: getToken,
    handleize: handleize,
    isJSONString: isJSONString,
    isValidJSONString: isValidJSONString,
    newSelectElement: newSelectElement,
    objectAttributes: objectAttributes,
    sleep: sleep,
    
    toggleHidden: toggleHidden,
    getControlValue: getControlValue
    
  };

})();	// End of LTK Module - IFFE pattern